<label [for]="id" class="field__label" aria-live="polite" aria-atomic="true">{{ label }}</label>

<jqxDateTimeInput #myDateTimeInput [theme]="'web'" [formatString]="'MM/dd/yyyy'" [width]="205" [height]="35"
                  (onValueChanged)="onValueChanged($event)" (keydown)="onKeyDown($event)" [disabled]="disabled" [tabindex]="0">
</jqxDateTimeInput>